// Products George has built. Rendered by Projects.jsx; facts only, no metrics.
export const projectsSection = {
  title: 'Projects',
  intro: 'Two products I built and run, from the first commit to deployment.',
};

export const projects = [
  {
    id: 'hydromastery',
    name: 'HydroMastery',
    url: 'https://www.hydromastery.com',
    oneLine: 'Personalised swim training and analytics for swimmers and coaches.',
    description:
      'George built this as a freelancer. It delivers personalised workouts and insightful analytics for swimmers and coaches. It was first deployed to Azure App Service and later migrated to AWS Elastic Beanstalk with S3 and a CloudFront CDN for performance and scalability. He designed and implemented features for distinct user roles: coaches, athletes, and administrators, giving each a tailored experience. He also set up a Miro board and a Jira board to run collaboration and project management with the client.',
    stack: [
      'React',
      'Express',
      'MongoDB Atlas',
      'Azure App Service',
      'AWS Elastic Beanstalk',
      'S3',
      'CloudFront',
      'Jira',
    ],
    status: 'Shipped',
    role: 'Freelance full-stack developer',
  },
  {
    id: 'yellow-ball-games',
    name: 'Yellow Ball Games',
    url: 'https://yellowballgames.com',
    oneLine: 'One place to run a racket-sport club, and to find and book a game.',
    description:
      'A platform for tennis, padel, and pickleball. It serves both sides of the net: clubs list courts, keep every booking in one calendar, take payment in-app, and manage memberships and renewals, while players discover courts nearby, book and pay in a few taps, split the bill with their group, and find a coach or a partner at their level. Built for iOS, Android, and web with Flutter, currently in the UK and Greece, taking early-access registrations for clubs and players.',
    stack: ['Flutter', 'iOS', 'Android', 'Web', 'Payments', 'Memberships'],
    status: 'In early access',
    role: 'Founder and developer',
  },
];
